import { memo, useEffect, useState } from 'react'
import Backdrop from '@mui/material/Backdrop'
import Modal from '@mui/material/Modal'
import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import SocietyCoinABI from '../abis/NeonTigerSociety.json';
import NeonTigerSocietyABI from '../abis/NeonTigerSociety.json';
import Staking_NTSctyABI from '../abis/Staking_NTScty.json';
import GoldTokenABI from '../abis/GoldToken.json';
import GoldPoolABI from '../abis/GoldPool.json';

import { GoldAddress, PoolAddress, SocietyCoinContract, NeonTigerSociety, Staking_NTScty } from '../global/constants'
import { BIG_ZERO } from '../global/constants'
import './card.scss'
import { useNoWalletContract } from '../hooks/useContract'
import { useEthers } from '@usedapp/core'
import { ethers } from 'ethers'
import { toast } from 'react-toastify'
import { QrReader } from 'react-qr-reader';
import QrCodeIcon from '@mui/icons-material/QrCode';
import CloseIcon from '@mui/icons-material/Close';
import CameraIcon from '@mui/icons-material/Camera';
import { Grid } from '@mui/material'

const NeonTigerCard = () => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#000000', // Background color set to black
        border: '1px solid #000000',
        borderRadius: '10px',
        boxShadow: 24,
        p: 4,
    }

    const styleb = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#000000', // Background color set to black
        border: '1px solid #000000',
        borderRadius: '10px',
        boxShadow: 24,
        pl: 4,
        pr: 4,
        pt: 10,
        pb: 10,
    }

    const { account } = useEthers()
    const goldTokenContract: any = useNoWalletContract(GoldTokenABI, GoldAddress);
    const goldPoolContract: any = useNoWalletContract(GoldPoolABI, PoolAddress);
    const societyContract: any = useNoWalletContract(SocietyCoinABI.abi, SocietyCoinContract);
    const neonSocietyContract: any = useNoWalletContract(NeonTigerSocietyABI.abi, NeonTigerSociety);
    const stakingContract: any = useNoWalletContract(Staking_NTSctyABI.abi, Staking_NTScty);
    const [balance, setBalance] = useState<any>(BIG_ZERO);
    const [approved, setApproved] = useState(false);
    const copycontract = './img/copycontract.png';

    const [opena, setOpena] = useState(false)
    const [claimAddress, setClaimAddress] = useState('')
    const [claimAmount, setClaimAmount] = useState('')
    const [userBalance, setUserBalance] = useState(0)
    const [userReward, setUserReward] = useState(0)
    const [totalBalance, setTotalBalance] = useState(0)
    const [totalReward, setTotalReward] = useState(0)
    const [expiredAt, setExpiredAt] = useState('')

    const handleOpena = () => setOpena(true)
    const handleClosea = () => setOpena(false)
    const [showQrScan, setShowQrScan] = useState(false);
    const openQrScanner = () => {
        setClaimAddress('');
        setShowQrScan(true)
    };
    const closeQrScanner = () => setShowQrScan(false);
    const [camera, setCamera] = useState('environment');
    const switchCamera = () => {
        if(camera == 'environment') {
            setCamera('user');
        } else {
            setCamera('environment')
        }
        setShowQrScan(false);
    }

    const [openb, setOpenb] = useState(false)
    const handleOpenb = () => setOpenb(true)
    const handleCloseb = () => setOpenb(false)
    const [openc, setOpenc] = useState(false);
const handleOpenc = () => setOpenc(true);
const handleClosec = () => setOpenc(false);

    // Admin Withdraw States and Modal
    const [opend, setOpend] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [withdrawAmount, setWithdrawAmount] = useState('');
    const [withdrawTo, setWithdrawTo] = useState(account || '');
    const [usdcBalance, setUsdcBalance] = useState(0);
    const handleOpend = () => setOpend(true);
    const handleClosed = () => setOpend(false);

    const copyAddress = () => {
        navigator.clipboard.writeText(PoolAddress);
        toast.success('✠  C o p i e d  ✠',
        {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
        })
    }

    const showError = (error: any) => {
        if (error.error){
            toast.error(
                error.error.data.message
                    .split('execution reverted: ')
                    .join(''),
                {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    hideProgressBar: true,
                },
            )
        }
        else {
            toast.error(error.message, {
                position: toast.POSITION.BOTTOM_RIGHT,
                hideProgressBar: true,
            })
        }
    }

    const approve = async () => {
        try {
            await goldTokenContract.approve(PoolAddress, ethers.constants.MaxUint256).then((tx: any) => {
                tx.wait().then((res: any) => {
                    setApproved(true)
                    toast.success('Approve successful', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        hideProgressBar: true,
                    })
                })
            })
        } catch (error) {
            showError(error);
        }
    }

    const deposit = async () => {
        try {
            await goldPoolContract.deposit(ethers.utils.parseUnits(claimAmount, 6)).then((tx: any) => {
                tx.wait().then((response: any) => {
                    toast.success('Deposit successful', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        hideProgressBar: true,
                    })
                })
            })
        } catch (error) {
            showError(error);
        }
    }

    const withdraw = async () => {
        try {
            await goldPoolContract.withdraw(ethers.utils.parseUnits(claimAmount, 6)).then((tx:any) => {
                tx.wait().then((response: any) => {
                    toast.success('Withdraw successful', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        hideProgressBar: true,
                    })
                })
            })
        } catch (error) {
            showError(error)
        }
    }

    const claimReward = async () => {
        try {
            await goldPoolContract.claimReward().then((tx:any) => {
                tx.wait().then((response: any) => {
                    toast.success('Reward Claimed', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        hideProgressBar: true,
                    })
                })
            })
        } catch (error) {
            showError(error)
        }
    }

    const checkApproved = async () => {
        try {
            let allowance = await goldTokenContract.allowance(account, PoolAddress);            
            let amount = ethers.utils.parseUnits(claimAmount, 6);

            if(Number(allowance) >= Number(amount)){
                setApproved(true)
            } else {
                setApproved(false);
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        checkApproved();
    },[claimAmount, account])

    const checkTokenBalance = async () => {
        try {
            if(account){
                const blnc = await goldTokenContract.balanceOf(account);
                setBalance(Number(blnc)/1e6);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const checkPoolStatus = async () => {
        try {
            if(account){
                

let blnc = await goldPoolContract.userStaked(account);
                setUserBalance(Number(blnc)/1e6);

                blnc = await goldPoolContract.userRewards(account);
                setUserReward(Number(blnc)/1e6);

                blnc = await goldPoolContract.poolBalance();
                setTotalBalance(Number(blnc)/1e6);

                blnc = await goldPoolContract.totalRewards();
                setTotalReward(Number(blnc)/1e6);

                let expiredAtTimeStamp = await goldPoolContract.rewardExpiry();
                const date = new Date(expiredAtTimeStamp * 1000);
                const options = {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    timeZoneName: 'short'
                };
                const formattedDate = date.toLocaleDateString('en-US', options);
                setExpiredAt(formattedDate);
            }
        } catch (error) {
            console.log(error)
        }
    }

    const checkUsdcBalance = async () => {
        try {
            const usdc = new ethers.Contract('0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359', ['function balanceOf(address) view returns (uint256)'], goldPoolContract.provider);
            const bal = await usdc.balanceOf(PoolAddress);
            setUsdcBalance(Number(bal) / 1e6);
        } catch (error) {
            console.log(error);
        }
    }

    const adminWithdraw = async () => {
        try {
            await goldPoolContract.adminWithdraw('0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359', withdrawTo, ethers.utils.parseUnits(withdrawAmount, 6)).then((tx: any) => {
                tx.wait().then(() => {
                    toast.success('USDC Withdrawn', {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        hideProgressBar: true,
                    });
                    handleClosed();
                    checkUsdcBalance();
                });
            });
        } catch (error) {
            showError(error);
        }
    }

    useEffect(()=> {
        checkTokenBalance();
        checkPoolStatus();
        checkUsdcBalance();
        if (account) {
            setIsAdmin(account.toLowerCase() === '0xfee3c75691e8c10ed4246b10635b19bfff06ce16');
        }
    },[account])

    return (
<div style={{ borderRadius: "20px", backgroundColor: "#00000080", padding: "20px 20px", border: "1px solid #daa52080", marginBottom: '10px' }}>

            <Box sx={{flexGrow: 1}} className={`coin-total`}>
                <Grid container spacing={2}>
                    <Grid item sm={12} xs={12}>
                        <Box sx={{flexGrow: 1}}>
                            <Grid container spacing={1} className='margin-top-device'>


                                 <Grid item xs={12}>
                                    


<div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '30px',
    gap: '10px'
}}>
    <p style={{
        color: '#daa520',
        fontSize: '1.8em',
        letterSpacing: '.15em',
        margin: 0
    }} className='card-title'>
        {`TEMPLAR N✠BILIUM CRUCIBLE`}
    </p>
    <img
        className='coin-number-contract'
        src={copycontract}
        onClick={() => copyAddress()}
        style={{ height: '24px', cursor: 'pointer' }}
        alt="Copy Contract"
    />
</div>





                                </Grid>
                                <Grid item xs={4}>
                                    <p style={{
                                        color:'#DAA520', 
                                        fontSize:'1.5em', 
                                        letterSpacing:'0.1em', 
                                        textAlign:'right', 
                                    }}
                                    className='card-title'
                                    >
                                        
                                    </p>
                                </Grid>
                            </Grid>
                            <Grid container spacing={1} className='margin-top-device'>
                                <Grid item xs={12}>
                                   





<p style={{
  fontSize: '1.3em',
  letterSpacing: '0.1em',
  color: '#DAA520',
  marginBottom: '20px',
}} className='card-sub-title'>
  
  <span>
    {'TOTAL G✠LD COMMITTED:      '} 
    {totalBalance.toFixed(2)} G✠LD
  </span><br />

  <span>
    {'TOTAL N✠BILIUM REFINED:    '} 
    {totalReward.toFixed(2)} G✠LD
  </span><br /><br />

  <span>
    {'YOUR G✠LD:                        '} 
    {userBalance.toFixed(2)} G✠LD
  </span><br />

  <span>
    {'YOUR N✠BILIUM:                '} 
    {userReward.toFixed(2)} G✠LD
  </span><br /><br />


</p>



                                </Grid>
                            </Grid>
                            <Grid container spacing={1} className='margin-top-device'>
                                <Grid item xs={4}>
                                    <button
                                            className='coin-button-receive'
                                            onClick={handleOpena}
                                            style={{backgroundColor:'#ffffffbf', color:'#000000'}}
                                        >
                                        {'COMMIT'}
                                    </button>
                                </Grid>
                                <Grid item xs={4}>
                                    <button
                                        className='coin-button-receive'
                                        onClick={handleOpenb}
                                        style={{backgroundColor:'#000000bf', color:'#ffffff'}}
                                    >
                                        {'WITHDRAW'}
                                    </button>
                                </Grid>
                               

<Grid item xs={4}>
  <button
    onClick={handleOpenc}
    className='coin-button-gift'
    style={{
      background: "linear-gradient(180deg, #FEE970, #FFAD06)",
      color: "#000000",
      marginBottom: '50px'
    }}
  >
    {'N✠BILIUM'}
  </button>
</Grid>


                            </Grid>

                            {/* Admin Section - Visible if connected wallet is 0xFEE3C75691E8C10eD4246b10635B19bfFf06Ce16 */}
                            {isAdmin && (
                                <Grid container spacing={1} className='margin-top-device'>
                                    <Grid item xs={12}>
                                        <p style={{
                                            fontSize: '1.3em',
                                            letterSpacing: '0.1em',
                                            color: '#DAA520',
                                            marginBottom: '20px',
                                        }}>
                                            USDC Balance in Pool: {usdcBalance.toFixed(2)} USDC
                                        </p>
                                        <p style={{
                                            fontSize: '1.3em',
                                            letterSpacing: '0.1em',
                                            color: '#DAA520',
                                            marginBottom: '20px',
                                        }}>
                                            User's Deposited G+LD: {userBalance.toFixed(2)} G+LD
                                        </p>
                                        <button
                                            className='coin-button-receive'
                                            onClick={handleOpend}
                                            style={{backgroundColor:'#ffffffbf', color:'#000000'}}
                                        >
                                            ADMIN WITHDRAW USDC
                                        </button>
                                    </Grid>
                                </Grid>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Box>
           


<Modal
  aria-labelledby='transition-modal-title'
  aria-describedby='transition-modal-description'
  open={opena}
  onClose={handleClosea}
  closeAfterTransition
  BackdropComponent={Backdrop}
  BackdropProps={{
    timeout: 500,
    style: { backgroundColor: 'rgba(0, 0, 0, 0.95)' },
  }}
>
  <Fade in={opena}>
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80vw',
        maxWidth: '400px',
        bgcolor: 'transparent',
        borderRadius: '20px',
        textAlign: 'center',
        px: 3,
      }}
    >
      {/* Header block with marginBottom: 90px */}
      <div style={{ marginBottom: '90px' }}>
        <p style={{
          fontSize: '1.6em',
          fontWeight: 'bold',
          letterSpacing: '.15em',
          color: '#DAA520',
          textAlign: 'center',
          margin: 0,
        }}>
          TEMPLAR
        </p>
        <p style={{
          fontSize: '1.6em',
          fontWeight: 'bold',
          letterSpacing: '.15em',
          color: '#DAA520',
          textAlign: 'center',
          margin: 0,
        }}>
          N✠BILIUM CRUCIBLE
        </p>
      </div>

      {/* Input */}
     




<TextField
  fullWidth
  label="COMMIT AMOUNT"
  value={claimAmount}
  onChange={(e) => setClaimAmount(e.target.value)}
  sx={{
    mb: 5,
    '& .MuiOutlinedInput-root': {
      borderRadius: '999px',
      paddingLeft: '16px',
      paddingRight: '16px',
      '& fieldset': {
        borderColor: '#ffc600',
      },
      '&:hover fieldset': {
        borderColor: '#ffc600',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#ffc600',
      },
      backgroundColor: 'transparent',
      color: '#ffc600',
    },
    '& .MuiInputLabel-root': {
      color: '#ffc600',
    },
    '& .MuiInputBase-input': {
      color: '#ffc600',
      fontWeight: 'bold',
    },
  }}
/>







      {/* Buttons */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
        <Button
          variant='outlined'
          fullWidth
          sx={{
            borderRadius: '50px',
            border: '2px solid #DAA520',
            color: '#DAA520',
            fontWeight: 'bold',
            letterSpacing: '.05em',
            py: 1.0,
            px: 3
          }}
          onClick={approved ? deposit : approve}
        >
          {approved ? 'DEPOSIT' : 'APPROVE'}
        </Button>

        <Button
          variant='outlined'
          fullWidth
          sx={{
            borderRadius: '50px',
            border: '2px solid #DAA520',
            color: '#DAA520',
            fontWeight: 'bold',
            letterSpacing: '.05em',
            py: 1.0,
            px: 3
          }}
          onClick={handleClosea}
        >
          CANCEL
        </Button>
      </Box>
    </Box>
  </Fade>
</Modal>






           <Modal
  aria-labelledby='transition-modal-title'
  aria-describedby='transition-modal-description'
  open={openb}
  onClose={handleCloseb}
  closeAfterTransition
  BackdropComponent={Backdrop}
  BackdropProps={{
    timeout: 500,
    style: { backgroundColor: 'rgba(0, 0, 0, 0.95)' },
  }}
>
  <Fade in={openb}>
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80vw',
        maxWidth: '400px',
        bgcolor: 'transparent',
        borderRadius: '20px',
        textAlign: 'center',
        px: 3,
      }}
    >
      <div style={{ marginBottom: '90px' }}>
        <p style={{
          fontSize: '1.6em',
          fontWeight: 'bold',
          letterSpacing: '.15em',
          color: '#DAA520',
          textAlign: 'center',
          margin: 0,
        }}>
          TEMPLAR
        </p>
        <p style={{
          fontSize: '1.6em',
          fontWeight: 'bold',
          letterSpacing: '.15em',
          color: '#DAA520',
          textAlign: 'center',
          margin: 0,
        }}>
          N✠BILIUM CRUCIBLE
        </p>
      </div>

      <TextField
        fullWidth
        label="WITHDRAW AMOUNT"
        value={claimAmount}
        onChange={(e) => setClaimAmount(e.target.value)}
        sx={{
          mb: 5,
          '& .MuiOutlinedInput-root': {
            borderRadius: '999px',
            paddingLeft: '16px',
            paddingRight: '16px',
            '& fieldset': {
              borderColor: '#ffc600',
            },
            '&:hover fieldset': {
              borderColor: '#ffc600',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#ffc600',
            },
            backgroundColor: 'transparent',
            color: '#ffc600',
          },
          '& .MuiInputLabel-root': {
            color: '#ffc600',
          },
          '& .MuiInputBase-input': {
            color: '#ffc600',
            fontWeight: 'bold',
          },
        }}
      />

      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
        <Button
          variant='outlined'
          fullWidth
          sx={{
            borderRadius: '50px',
            border: '2px solid #DAA520',
            color: '#DAA520',
            fontWeight: 'bold',
            letterSpacing: '.05em',
            py: 1.0,
            px: 3
          }}
          onClick={withdraw}
        >
          CONFIRM
        </Button>

        <Button
          variant='outlined'
          fullWidth
          sx={{
            borderRadius: '50px',
            border: '2px solid #DAA520',
            color: '#DAA520',
            fontWeight: 'bold',
            letterSpacing: '.05em',
            py: 1.0,
            px: 3
          }}
          onClick={handleCloseb}
        >
          CANCEL
        </Button>
      </Box>
    </Box>
  </Fade>
</Modal>

<Modal
  aria-labelledby='transition-modal-title'
  aria-describedby='transition-modal-description'
  open={openc}
  onClose={handleClosec}
  closeAfterTransition
  BackdropComponent={Backdrop}
  BackdropProps={{
    timeout: 500,
    style: { backgroundColor: 'rgba(0, 0, 0, 0.95)' },
  }}
>
  <Fade in={openc}>
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80vw',
        maxWidth: '400px',
        bgcolor: 'transparent',
        borderRadius: '20px',
        textAlign: 'center',
        px: 3,
      }}
    >
      <div style={{ marginBottom: '90px' }}>
        <p style={{
          fontSize: '1.6em',
          fontWeight: 'bold',
          letterSpacing: '.15em',
          color: '#DAA520',
          textAlign: 'center',
          margin: 0,
        }}>
          TEMPLAR
        </p>
        <p style={{
          fontSize: '1.6em',
          fontWeight: 'bold',
          letterSpacing: '.15em',
          color: '#DAA520',
          textAlign: 'center',
          margin: 0,
        }}>
          N✠BILIUM CRUCIBLE
        </p>
      </div>

      <p style={{
        fontSize: '1.2em',
        color: '#DAA520',
        fontWeight: 'bold',
        letterSpacing: '.1em',
        marginBottom: '32px'
      }}>
        REFINE {Number(userReward).toFixed(2)} G✠LD to N✠BILIUM?
      </p>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
        <Button
          variant='outlined'
          fullWidth
          sx={{
            borderRadius: '50px',
            border: '2px solid #DAA520',
            color: '#DAA520',
            fontWeight: 'bold',
            letterSpacing: '.05em',
            py: 1.0,
            px: 3
          }}
          onClick={() => {
            claimReward();
            handleClosec();
          }}
        >
          REFINE
        </Button>

        <Button
          variant='outlined'
          fullWidth
          sx={{
            borderRadius: '50px',
            border: '2px solid #DAA520',
            color: '#DAA520',
            fontWeight: 'bold',
            letterSpacing: '.05em',
            py: 1.0,
            px: 3
          }}
          onClick={handleClosec}
        >
          CANCEL
        </Button>
      </Box>
    </Box>
  </Fade>
</Modal>

{/* Admin Withdraw Modal */}
<Modal
  aria-labelledby='transition-modal-title'
  aria-describedby='transition-modal-description'
  open={opend}
  onClose={handleClosed}
  closeAfterTransition
  BackdropComponent={Backdrop}
  BackdropProps={{
    timeout: 500,
    style: { backgroundColor: 'rgba(0, 0, 0, 0.95)' },
  }}
>
  <Fade in={opend}>
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80vw',
        maxWidth: '400px',
        bgcolor: 'transparent',
        borderRadius: '20px',
        textAlign: 'center',
        px: 3,
      }}
    >
      <div style={{ marginBottom: '90px' }}>
        <p style={{
          fontSize: '1.6em',
          fontWeight: 'bold',
          letterSpacing: '.15em',
          color: '#DAA520',
          textAlign: 'center',
          margin: 0,
        }}>
          ADMIN WITHDRAW
        </p>
        <p style={{
          fontSize: '1.6em',
          fontWeight: 'bold',
          letterSpacing: '.15em',
          color: '#DAA520',
          textAlign: 'center',
          margin: 0,
        }}>
          USDC FROM POOL
        </p>
      </div>

      <TextField
        fullWidth
        label="WITHDRAW AMOUNT"
        value={withdrawAmount}
        onChange={(e) => setWithdrawAmount(e.target.value)}
        sx={{
          mb: 2,
          '& .MuiOutlinedInput-root': {
            borderRadius: '999px',
            paddingLeft: '16px',
            paddingRight: '16px',
            '& fieldset': {
              borderColor: '#ffc600',
            },
            '&:hover fieldset': {
              borderColor: '#ffc600',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#ffc600',
            },
            backgroundColor: 'transparent',
            color: '#ffc600',
          },
          '& .MuiInputLabel-root': {
            color: '#ffc600',
          },
          '& .MuiInputBase-input': {
            color: '#ffc600',
            fontWeight: 'bold',
          },
        }}
      />

      <TextField
        fullWidth
        label="WITHDRAW TO ADDRESS"
        value={withdrawTo}
        onChange={(e) => setWithdrawTo(e.target.value)}
        sx={{
          mb: 5,
          '& .MuiOutlinedInput-root': {
            borderRadius: '999px',
            paddingLeft: '16px',
            paddingRight: '16px',
            '& fieldset': {
              borderColor: '#ffc600',
            },
            '&:hover fieldset': {
              borderColor: '#ffc600',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#ffc600',
            },
            backgroundColor: 'transparent',
            color: '#ffc600',
          },
          '& .MuiInputLabel-root': {
            color: '#ffc600',
          },
          '& .MuiInputBase-input': {
            color: '#ffc600',
            fontWeight: 'bold',
          },
        }}
      />

      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '16px' }}>
        <Button
          variant='outlined'
          fullWidth
          sx={{
            borderRadius: '50px',
            border: '2px solid #DAA520',
            color: '#DAA520',
            fontWeight: 'bold',
            letterSpacing: '.05em',
            py: 1.0,
            px: 3
          }}
          onClick={adminWithdraw}
        >
          WITHDRAW
        </Button>

        <Button
          variant='outlined'
          fullWidth
          sx={{
            borderRadius: '50px',
            border: '2px solid #DAA520',
            color: '#DAA520',
            fontWeight: 'bold',
            letterSpacing: '.05em',
            py: 1.0,
            px: 3
          }}
          onClick={handleClosed}
        >
          CANCEL
        </Button>
      </Box>
    </Box>
  </Fade>
</Modal>
            
    
    
    {
  showQrScan && (
    <Box
      sx={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#00000080',
        padding: '24px',
        border: '2px solid #DAA520',
        borderRadius: '20px',
        zIndex: 999999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '90vw',
        maxWidth: '400px',
        boxShadow: '0 0 20px #DAA52080'
      }}
    >
      <CloseIcon
        onClick={closeQrScanner}
        sx={{
          position: 'absolute',
          top: 10,
          right: 10,
          color: '#DAA520',
          cursor: 'pointer',
          fontSize: '28px',
        }}
      />
      <CameraIcon
        onClick={switchCamera}
        sx={{
          position: 'absolute',
          top: 10,
          left: 10,
          color: '#DAA520',
          cursor: 'pointer',
          fontSize: '28px',
        }}
      />
      <QrReader
        constraints={{ facingMode: camera }}
        onResult={(result, error) => {
          if (!!result) {
            setClaimAddress(result.getText().replace('ethereum', '').slice(0, 42));
            closeQrScanner();
          }
          if (!!error) {
            console.info(error);
          }
        }}
        style={{ width: '100%' }}
      />
      {account && (
        <p style={{
          color: '#DAA520',
          fontSize: '0.9em',
          marginTop: '12px',
          wordBreak: 'break-word',
          letterSpacing: '0.1em',
          textAlign: 'center',
          textTransform: 'uppercase'
        }}>
          {account}
        </p>
      )}
    </Box>
  )
}




      
  )
}

                
                :
                ''
            }
        </div>
    )
}

export default memo(NeonTigerCard)